export function isvalidEmail(str) {
    const valid_email = /^([\w-_]+(?:\.[\w-_]+)*)@((?:[a-z0-9]+(?:-[a-zA-Z0-9]+)*)+(?:\.[a-z]{2,6})*)$/i
    return valid_email.test(str)
  }


// WEBPACK FOOTER //
// ./src/utils/validate.js